const dashboardModule = {
  namespaced: true,
  state: () => ({
    modal: {
      alertDisconnectDomain: {
        show: false,
        action: ''
      },

      image: {
        show: false,
        page: ''
      },

      files: {
        show: false,
        page: ''
      },

      videos: {
        show: false,
        page: ''
      },

      transfer: {
        show: false,
        config: ''
      },

      delete: {
        show: false,
        config: {}
      },

      publicLink: {
        show: false,
        config: ''
      },

      publish: {
        show: false,
        config: ''
      },

      moveCategory: {
        show: false,
        website: {}
      },

      saveTour: {
        show: true,
        config: '',
        type: 'save',
      }
    },
  }),
  mutations: {
    SET_MODAL_PUBLISH_LINK({modal}, {show, config = '', action = ''}) {
      modal.publicLink = {
        show: show,
        action: action,
        config: config
      };
    },

    SET_MODAL_TRANSFER({modal}, {show, config = ''}) {
      if (config.dominio)
        modal.alertDisconnectDomain = {
          show: true,
          action: 'transfer'
        };
      else {
        modal.transfer = {
          show: show,
          config: config
        };
      }
    },

    SET_MODAL_DELETE({modal}, { show = true, config}) {
      console.log(show, config)
      if (config.dominio) {
        modal.alertDisconnectDomain = {
          show: true,
          action: 'delete'
        };
      } else {
        modal.delete = {
          show: show,
          config: config
        };
      }
    },

    SET_MODAL_DOMAIN({modal}, {show, config = ''}) {
      modal.domain = {
        show: show,
        config: config
      };
    },

    SET_MODAL_MOVE_CATEGORY({ modal }, {show = true, website = {} }) {
      console.log(show, website);
      modal.moveCategory = {
        show: show,
        website: website
      };
    },

    SET_MODAL_DISCONECT_DOMAIN({modal}, {show, action = ''}) {
      modal.alertDisconnectDomain = {
        show: show,
        action: action
      };
    },
  },
  getters: {
    modal(state) {
      return state.modal;
    }
  },
  actions: {
    activeOrManagePublishLink({commit}, payload) {
      commit('SET_MODAL_PUBLISH_LINK', payload);
    },
    transferWebsite({commit}, payload) {
      commit('SET_MODAL_TRANSFER', payload);
    },
    confirmDeleteWebsite({commit}, payload) {
      commit('SET_MODAL_DELETE', payload);
    },
    moveCategory({commit}, payload) {
      commit('SET_MODAL_MOVE_CATEGORY', payload);
    },
    closeModalDisconnectDomain({commit}) {
      commit('SET_MODAL_DISCONECT_DOMAIN', { show : false });
    },
  }
};
export default dashboardModule;



// WEBPACK FOOTER //
// ./src/js/storeModules/dashboardModule.js